import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './Notification.module.scss';
import { CloseIcon, ExclamationTriangleIcon, CheckCircleIcon, InfoOutlineIcon, GiftWrappingIcon, } from '../Icons';
import { NotificationVariant } from '../../enums';
import { PureButton } from '../../basics';
function Notification({ message, a11yText, children, onRequestClose, variant = NotificationVariant.Error, }) {
    const getIconBasedOnVariant = () => {
        switch (variant) {
            case NotificationVariant.Error:
            case NotificationVariant.Warning:
                return _jsx(ExclamationTriangleIcon, { className: classNames('mr-1x', styles.icon) });
            case NotificationVariant.Success:
                return _jsx(CheckCircleIcon, { className: classNames('mr-1x', styles.icon) });
            case NotificationVariant.Promo:
                return (_jsx(GiftWrappingIcon, { className: classNames('mb-1-5x mb-md-0', styles.icon, styles[variant]) }));
            default:
                return _jsx(InfoOutlineIcon, { className: classNames('mr-1x', styles.icon) });
        }
    };
    return (_jsx("div", { className: classNames('p-2x mb-2x', styles.notification, styles[variant]), children: _jsxs("div", { className: classNames('d-flex', styles.notificationHead), children: [_jsx("div", { className: classNames(styles.notificationTitle, styles[variant]), children: getIconBasedOnVariant() }), _jsxs("div", { className: classNames('w-100', styles.notificationTitle, styles[variant]), children: [_jsx("div", { className: classNames(styles.text), children: message }), children && _jsx("div", { children: children })] }), onRequestClose && (_jsxs(PureButton, { className: classNames('d-flex align-self-start', styles.closeIcon), onClick: () => onRequestClose(), children: [_jsx("span", { className: "screenReaderOnly", children: a11yText }), _jsx(CloseIcon, {})] }))] }) }));
}
export { Notification };
